<ng-container *ngIf="(service.user | async) === null; else signedIn">
  <button mat-button routerLink="/konto">
    <mat-icon>account_circle</mat-icon>&nbsp;Anmelden
  </button>
</ng-container>

<ng-template #signedIn>
  <button mat-icon-button [matMenuTriggerFor]="menu">
    <div id="user-pic-40" [ngStyle]="service.profilePicStyles"></div>
  </button>
  <mat-menu #menu="matMenu">
    <button mat-menu-item routerLink="/konto">
      <mat-icon svgIcon="{{service.userAuthProviderIcon}}"></mat-icon>
      <span>Buchungskonto</span>
    </button>
    <button mat-menu-item (click)="service.signOut()">
      <mat-icon>account_circle</mat-icon>
      <span>Abmelden</span>
    </button>
  </mat-menu>
</ng-template>
